import type { ActiveContractByCategory, ActiveContractCurrentPeriod } from '../types';

import { diasAte } from './periodoContrato';

const DIAS_PARA_TESTE_ACABANDO = 7;
const PROPORCAO_SALDO_BAIXO = 0.8;

export function testeAcabando(contrato: ActiveContractByCategory): boolean {
  if (contrato.status !== 'TRIAL' || !contrato.trialEnd) return false;
  const dias = diasAte(contrato.trialEnd);
  return dias >= 0 && dias <= DIAS_PARA_TESTE_ACABANDO;
}

export function saldoBaixo(periodo: ActiveContractCurrentPeriod | null | undefined): boolean {
  const total = periodo?.totalBalance ?? null;
  if (!periodo || total === null || total <= 0) return false;
  return periodo.usedBalance / total >= PROPORCAO_SALDO_BAIXO;
}

export function saldoDeMensagemBaixo(
  periodo: ActiveContractCurrentPeriod | null | undefined,
): boolean {
  const total = periodo?.messageBalance ?? null;
  if (!periodo || total === null || total <= 0) return false;
  return periodo.messageUsed / total >= PROPORCAO_SALDO_BAIXO;
}

export function percentualUsado(periodo: ActiveContractCurrentPeriod): number {
  const total = periodo.totalBalance ?? 0;
  if (total <= 0) return 0;
  return Math.round((periodo.usedBalance / total) * 100);
}
